import React from 'react';
import { proofPoints } from '../../data/site';
export function ProofStrip() {
  return <section aria-label="What makes KeyTurn different" className="border-b border-line bg-cream" data-id="element-251" data-mp="2etfe75cojynl">
      <ul className="mx-auto grid max-w-[1180px] grid-cols-1 gap-x-10 px-5 sm:grid-cols-2 sm:px-8 lg:grid-cols-4" data-id="element-252" data-mp="2jt1qnckopavc">
        {proofPoints.map(point => <li key={point} className="border-b border-line py-6 text-[13.5px] font-medium leading-snug text-charcoal-500 last:border-b-0 lg:border-b-0" data-id="element-253" data-mp="2or3gcgcm88fs">
            {point}
          </li>)}
      </ul>
    </section>;
}